// Open table-session derivation for the POS V2 table page. Pure function
// (no store access) so the header chip logic is unit-testable like
// pos-compaction; the caller feeds the table's pending orders.
import { IOrder, ITableSessionEmbed } from '@/interfaces/IOrder';

/**
 * Derives the table's open session from its pending orders' read-bridge
 * embeds. All pending orders of a table normally share one session, but
 * embeds can briefly disagree: covers-only PATCHes refresh a single pending
 * order over WS (no order row changes), and moves reattach orders one by
 * one. The freshest embed wins, compared by the session's own updatedAt
 * stamp (falling back to the order's updatedAt for pre-stamp payloads).
 * Returns null when no pending order carries an embed (pre-sessions data).
 */
export function deriveOpenTableSession(
  orders: IOrder[]
): ITableSessionEmbed | null {
  let best: ITableSessionEmbed | null = null;
  let bestStamp = -Infinity;

  for (const order of orders) {
    if (!order.tableSession) continue;
    const stamp = new Date(
      order.tableSession.updatedAt ?? order.updatedAt
    ).getTime();
    const ms = Number.isFinite(stamp) ? stamp : 0;
    if (ms >= bestStamp) {
      best = order.tableSession;
      bestStamp = ms;
    }
  }

  return best;
}
